import React from 'react';
import { useParams } from 'react-router-dom';
import { ActivityDetails } from '@/components/activities/ActivityDetails';
import { PageContainer } from '@/components/layout/PageContainer';
import { AppBreadcrumbs } from '@/components/layout/AppBreadcrumbs';

export const ActivityDetailsPage: React.FC = () => {
  const { id } = useParams();
  const activityId = parseInt(id || '0');

  return (
    <PageContainer width="wide" className="space-y-4">
      <AppBreadcrumbs />
      <ActivityDetails 
        activityId={activityId} 
        canEdit={true}
      />
    </PageContainer>
  );
};
